
const part1 : string[] = [
	"funny",
	"angry",
	//"green" !!green is not a creative color
	"yellow",
	"purple",
	"fuzzy",
	"shiny",
	"thoughtful",
	"rugged",
	"loud",
	"antique",
	"wonderful",
	"inspiring"
];

const part2 : string[] = [
	"walrus",
	"cat",
	"hamster",
	"flower",
	"wizard",
	"couch",
	"cabbage",
	"burger",
	"mustache",
	"platypus",
	"baguette",
	"vase", 
	"painting",
	"trumpet",
	"cello",
	"number",
	"book",
	"lamppost"
];


export function GenerateFunnyNameHehe () : string {
	const p1 : string = part1[RandomInt(0, part1.length-1)]
	const p2 : string = part2[RandomInt(0, part2.length-1)]
	return `${p1} ${p2}`
}


function RandomInt (min: number, max: number) : number {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}